<template>
  <div style="margin: 10px">
    <el-row>
      <el-col :span="24">
        <el-card
          class="box-card"
          style="height: calc(100vh - 200px); position: relative"
        >
          <el-row>
            <el-col
              :xs="12"
              :sm="12"
              :md="12"
              :lg="8"
              :xl="6"
              v-for="(item, index) in tableData"
              :key="index"
              @click.native.prevent="
                $router.push({
                  path: '/home/bulletDetail',
                  query: {
                    id: item.id,
                  },
                })
              "
            >
              <div class="menuBox">
                <i
                  class="el-icon-circle-close"
                  id="close"
                  @click.stop="deleteRow(index, item)"
                ></i>
                <i
                  class="el-icon-info info"
                  @click.stop="
                    getstatus === '1' ? update('update', item) : null
                  "
                ></i>
                <div class="menuIcon">
                  <img :src="settings.apiBaseImg + item.logo" alt="" />
                </div>
                <div class="menuTitle">
                  {{ item.title }}
                </div>
              </div>
            </el-col>
          </el-row>
          <button
            class="bulleBtn bulletAdd"
            type="button"
            @click="update('add')"
            v-if="getstatus === '1'"
          >
            新增应用
          </button>
          <button
            class="bulleBtn bulletDel"
            type="button"
            @click="del"
            v-if="getstatus === '1'"
          >
            {{ delBtn }}
          </button>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  data () {
    return {
      form: {
        title: ''
      },
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      loading: false,
      srcList: '',
      visiable: '',
      flag: true,
      delBtn: '删除应用',
      getstatus: localStorage.getItem('status')
    }
  },
  created () {
    this.getData(this.currentPage, this.pageSize)
  },
  methods: {
    preview (rows) {
      this.visiable = true
      this.srcList = ''
      this.srcList = this.settings.apiBaseImg + rows
    },
    // 获取列表数据
    getData (currentPage, pageSize) {
      this.loading = true
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/application/list',
        params: {
          title: this.form.title,
          pageSize: pageSize,
          pageNum: currentPage
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.loading = false
          this.tableData = res.data.data
          this.total = res.data.total
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    clear () {
      this.form.title = ''
      this.getData(this.currentPage, this.pageSize)
    },
    // 修改/添加
    update (iden, rows) {
      this.$router.push({
        path: '/home/bulletUpdate',
        query: {
          rows: rows,
          iden: iden
        }
      })
    },
    // 删除
    deleteRow (index, rows) {
      var obj = this
      this.$confirm('此操作将永久删除该应用信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        obj.$http({
          method: 'get',
          url: 'api/v1/application/del',
          params: {
            id: rows.id
          }
        }).then((res) => {
          if (res.data.status == 200) {
            obj.$message.success(res.data.message)
            obj.getData(this.currentPage, this.pageSize)
          } else {
            obj.$message.error(res.data.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    del () {
      if (this.visiable) {
        for (var i = 0; i < document.getElementsByClassName('menuBox').length; i++) {
          document.getElementsByClassName('menuBox')[i].children[0].style.display = 'none'
          document.getElementsByClassName('menuBox')[i].children[1].style.display = 'none'
        }
        this.visiable = false
        this.delBtn = '删除应用'
      } else {
        for (var i = 0; i < document.getElementsByClassName('menuBox').length; i++) {
          document.getElementsByClassName('menuBox')[i].children[0].style.display = 'block'
          document.getElementsByClassName('menuBox')[i].children[1].style.display = 'none'
        }
        this.visiable = true
        this.delBtn = '取消删除'
      }
    },
    selectDel () {
      if (this.$refs.multipleTable.selection.length == 0) {
        this.$message.error('请选择要删除的表格信息！')
        return
      }
      var list = []
      for (var i = 0; i < this.$refs.multipleTable.selection.length; i++) {
        list.push(this.$refs.multipleTable.selection[i].id)
      }
      this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        var obj = this
        obj.$http({
          method: 'get',
          url: 'api/v1/picmate/delete/multiple',
          params: {
            ids: list.toString()
          }
        }).then((res) => {
          if (res.data.status == 200) {
            obj.$message.success('删除成功')
            this.getData(this.currentPage, this.pageSize)
          } else {
            obj.$message.error(res.data.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 分页事件
    handleSizeChange (val) {
      this.pageSize = val // 将每页显示的条数 = 改变的值
      this.getData(this.currentPage, this.pageSize)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getData(this.currentPage, this.pageSize)
    },
    // 全选
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    }
  }
}
</script>

<style scoped="scoped">
.menuBox {
  height: 200px;
  background: #ffffff;
  border-radius: 15px;
  background-size: 100% 100%;
  padding: 40px 0;
  margin-bottom: 20px;
  transition: all 0.3s;
  cursor: pointer;
  border: 1px solid #b1b1c1;
  position: relative;
  margin-left: 40px;
}

.menuBox #close {
  font-size: 24px;
  color: #cccccc;
  position: absolute;
  right: -17px;
  top: -15px;
  display: none;
  cursor: pointer;
  z-index: 99;
}

.menuBox .info {
  font-size: 30px;
  color: #cccccc;
  position: absolute;
  right: -20px;
  top: -15px;
  cursor: pointer;
  z-index: 99;
  display: none;
}

.menuBox:hover .info {
  display: block;
}

.menuIcon {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  transition: all 0.3s;
}

.menuIcon img {
  width: 75px;
}

.menuTitle {
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #808080;
  margin-top: 20px;
  transition: all 0.3s;
}

.menuBox:hover {
  transition: all 0.3s;
  border: 1px solid #403e68;
  box-shadow: 0 2px 15px 0 rgb(0 0 0 / 10%);
}

.menuBox:hover .menuIcon {
  transition: all 0.3s;
  transform: scale(0.8);
}

.menuBox:hover .menuTitle {
  color: #3d3d63;
  transition: all 0.3s;
}

/deep/ .el-page-header {
  margin-bottom: 30px;
}

.bulleBtn {
  width: 98px;
  height: 40px;
  border-radius: 5px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  background-color: transparent;
  position: absolute;
  bottom: 10%;
  right: 30px;
  cursor: pointer;
}

.bulletAdd {
  right: 150px;
  border: 1px solid #f4ad3a;
  color: #f4ad3a;
}

.bulletDel {
  color: #4d4d4d;
  border: 1px solid #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/system/bullet/bullet.vue